import { v4 as uuidv4 } from 'uuid';

export function generateUid(): string {
  return uuidv4();
}
